import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LocationServiceService } from '../../Model/LocationMaster/location-service.service';
import { NavigationExtras, Router } from '@angular/router';
import { CommonService } from '../../Model/Common/common.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import pako from 'pako';
import { SessionService } from '../../Util/Session/session.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-location-view',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbPaginationModule, DataTablesModule, LoaderComponent,NgSelectModule],
  templateUrl: './location-view.component.html',
  styleUrl: './location-view.component.scss'
})
export class LocationViewComponent implements OnInit, OnDestroy {
  Status: string = 'Active';
  isDisabled: boolean = false;
  public User: any = null;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  SiteMasterData: any = [];
  SiteData: any;

  SiteMasterExcel: any[] = [];
  BranchMaster: any[] = [];
  BranchId : any = null;
  dtoptions: DataTables.Settings = {};
  constructor(private router: Router,
    private locationservice: LocationServiceService,
    protected common: CommonService,
    private sessionService: SessionService,
    private download: DownloadSampleService,
    private toast: ToastService,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad2('Branch');
    // this.getData();
    this.common.CheckExpiry();
    //this.getData();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  async getData() {
    await new Promise(f => setTimeout(f, 400));
    const Sitemasterdata = {
      SelectType: '1',
      SiteMasterId: '',
      Status: this.Status,
      UserId: this.User.UserId,
      BranchID : this.BranchId
    }
    this.isDisabled = true;
    this.locationservice.SiteMasterLoadCompress(Sitemasterdata).subscribe({
      next: (response) => {
        this.SiteData = response;
        const compressedData = Uint8Array.from(atob(this.SiteData), c => c.charCodeAt(0));
        let decompressedData = pako.inflate(compressedData, { to: 'string' });
        this.SiteMasterData = JSON.parse(decompressedData).Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.SiteData = null;
        decompressedData = '';
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error: any) => {
        console.log(error);
        this.isDisabled = false;
      },
    });
  }
  navigateToLocationComponent() {
    this.router.navigate(['master/locationmap']);
  }
  onEditClick(element: any): void {
    let navigationID: NavigationExtras = {
      queryParams: {
        editMode: true,
        SelectType: '2',
        SiteMasterId: element.SiteMasterId
      }
    };
    this.router.navigate(['master/locationmap'], navigationID);
  }

  exportToExcel(type: string, filename: string) {
    this.isDisabled = true
    const data = {
      SelectType: type,
      Year: '',
      LoginUserId : this.User.UserId
    }
    this.download.ESS_ExcelDump(data).subscribe(
      (data: any) => {
        this.SiteMasterExcel = data;
        if (this.SiteMasterExcel.length > 0) {
          this.download.exportToExcel(this.SiteMasterExcel, filename);
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
  
  ComboLoad2(Combotype: String) {
    this.isDisabled = true;
    if (true || (Combotype == 'Branch')) {
      this.locationservice.ComboLoad({
        'SelectType': Combotype, 
        'UserId': this.User.UserId
      }).subscribe({
        next: (response: { Table: any; }) => {
          if (Combotype == 'Branch') {
            this.BranchMaster = response.Table;
          }
          this.isDisabled = false;
        },
        complete: () => {
        },
        error: () => {
          this.isDisabled = false;
        },
      });
    } else {
      this.isDisabled = false;
    }
  }
  onchange(){
    this.SiteMasterData=[]
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
